import React,{useCallback,useEffect,useState} from 'react';
/**
 * Organization-scoped administration. No direct writes to organization_members:
 * every invitation and role change is checked again in Supabase RPCs.
 */
export default function StaffManagement({organization,client}){
 const [team,setTeam]=useState(null),[busy,setBusy]=useState(false),
 [email,setEmail]=useState(''),[role,setRole]=useState('operator'),
 [message,setMessage]=useState(''),[error,setError]=useState(''),[link,setLink]=useState('');
 const refresh=useCallback(async()=>{
  if(!organization?.id)return;
  const {data,error:e}=await client.rpc('pdv_team_snapshot',{p_org:organization.id});
  if(e)throw new Error('Não foi possível carregar a equipe.');
  if(data?.organization_id!==organization.id||!Array.isArray(data.members))throw new Error('Empresa inválida.');
  setTeam(data);
 },[client,organization?.id]);
 useEffect(()=>{let live=true;setTeam(null);setError('');setLink('');
  if(!organization?.id)return;
  client.rpc('pdv_team_snapshot',{p_org:organization.id}).then(({data,error:e})=>{
   if(!live)return;
   if(e||data?.organization_id!==organization.id)setError('Não foi possível consultar a equipe.');
   else setTeam(data);
  }).catch(()=>{if(live)setError('Não foi possível consultar a equipe.');});
  return()=>{live=false};
 },[organization?.id,client]);
 async function invite(e){
  e.preventDefault();setBusy(true);setError('');setMessage('');setLink('');
  try{
   const {data,error:x}=await client.rpc('pdv_invite_operator',{
    p_org:organization.id,p_email:email.trim().toLowerCase(),p_role:role,p_permissions:{}
   });
   if(x||!data?.ok||!data?.activation_url)throw Error('Falha ao criar convite.');
   setLink(data.activation_url);setEmail('');
   setMessage('Convite criado. Envie o link ao funcionário por um canal privado.');
   await refresh();
  }catch(e){setError(e.message)}finally{setBusy(false)}
 }
 async function modify(member,nextRole,nextStatus){
  if(!window.confirm('Confirmar alteração de acesso deste operador?'))return;
  setBusy(true);setError('');setMessage('');
  try{
   const {data,error:x}=await client.rpc('pdv_team_set_member',{
    p_org:organization.id,p_user:member.user_id,
    p_role:nextRole,p_status:nextStatus
   });
   if(x||!data?.ok)throw Error('Não foi possível alterar as permissões.');
   setMessage('Acesso do operador atualizado.');await refresh();
  }catch(e){setError(e.message)}finally{setBusy(false)}
 }
 return <section className="admin">
  <div className="pageTitle"><div>
   <p className="eyebrow">EQUIPE POR EMPRESA</p><h1>Operadores e permissões</h1>
   <p className="muted">Convide funcionários para {organization.name}. Cada empresa mantém usuários e permissões próprios.</p>
  </div></div>
  <section className="panel">
   <h2>Convidar operador</h2>
   <form onSubmit={invite} className="staffForm">
    <label>E-mail do funcionário
     <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="operador@empresa.com"/>
    </label>
    <label>Perfil
     <select value={role} onChange={e=>setRole(e.target.value)}>
      <option value="operator">Operador</option><option value="viewer">Consulta</option>
      <option value="admin">Administrador</option>
     </select>
    </label>
    <button type="submit" disabled={busy||!email.trim()}>Gerar convite seguro</button>
   </form>
   {link&&<div className="panel" role="status"><strong>Convite válido por 72 horas</strong>
    <input aria-label="Link de ativação" readOnly value={link} onFocus={e=>e.target.select()}/>
    <button type="button" onClick={()=>navigator.clipboard.writeText(link).then(()=>setMessage('Link copiado.')).catch(()=>setMessage('Selecione e copie o link acima.'))}>Copiar convite</button>
   </div>}
  </section>
  <section className="panel"><div className="line"><h2>Equipe cadastrada</h2>
   <button type="button" disabled={busy} onClick={()=>refresh().catch(()=>setError('Falha ao atualizar equipe.'))}>Atualizar</button></div>
   {!team?<p>Carregando equipe…</p>:
    <div className="staffList">{team.members.map(m=><div className="staffRow" key={m.user_id}>
     <div><strong>{m.display_name||m.email||'Usuário'}</strong><small>{m.email} · {m.status==='active'?'Ativo':'Inativo'}</small></div>
     {m.role==='owner'?<span>Proprietário</span>:<div className="staffActions">
      <select aria-label={'Perfil de '+(m.email||'operador')} value={m.role}
       disabled={busy} onChange={e=>modify(m,e.target.value,m.status)}>
       <option value="admin">Administrador</option><option value="operator">Operador</option>
       <option value="viewer">Consulta</option>
      </select>
      <button type="button" disabled={busy} onClick={()=>modify(m,m.role,m.status==='active'?'inactive':'active')}>
       {m.status==='active'?'Desativar':'Ativar'}
      </button>
     </div>}
    </div>)}</div>}
   {!!team?.invitations?.length&&<details><summary>Convites recentes ({team.invitations.length})</summary>
    {team.invitations.map(i=><p key={i.id}>{i.email} · {i.role} · {i.status}</p>)}
   </details>}
  </section>
  {message&&<p className="success" role="status">{message}</p>}
  {error&&<p className="error" role="alert">{error}</p>}
 </section>;
}
